import { useFormContext } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useGetScheduleOptions } from "api/queries/location/useGetScheduleOptions";

export default function useGetMultiStop() {
  const { watch } = useFormContext();
  const routerLocation = useLocation();
  const location = watch("organizational.location");
  const { data }: any = useGetScheduleOptions(location, {
    enabled: !!location,
  });

  const allowAsapDelivery = data?.schedule_options?.allow_asap_delivery;

  // Check if URL contains 'quote-request'
  const isQuoteRequestUrl = routerLocation.pathname.includes("quote-request");
  const isMultiStopQuoteRequest = isQuoteRequestUrl ? data?.schedule_options?.multi_stops_enabled : false;

  return { isMultiStopQuoteRequest, allowAsapDelivery };
}
